// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
import React, { Fragment, lazy, Suspense, useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { encodeAdf } from '@atlassian/conversation-assistant-content-renderer';

import { StatusCitation } from '../ai-answer-body/ai-answer-result/rendered/status-citation';

const containerStyles = xcss({
	minHeight: '106px',
	paddingTop: 'space.100',
	paddingRight: 'space.300',
	paddingBottom: 'space.100',
	paddingLeft: 'space.300',
});

const containerStylesWithoutStreamingExpand = xcss({
	maxHeight: '160px',
	overflow: 'hidden',
});

const ReactRenderer = lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_.renderer" */ '@atlaskit/renderer').then(
		({ ReactRenderer }) => {
			return {
				default: ReactRenderer,
			};
		},
	),
);

const MarkdownRenderer = lazy(() =>
	import(/* webpackChunkName: "react-markdown" */ 'react-markdown').then(
		({ default: ReactMarkdown }) => {
			return {
				default: ReactMarkdown,
			};
		},
	),
);

export const AIAnswerLoadingStream = ({ markdown }: { markdown: string }) => {
	const docContent = useMemo(() => encodeAdf(markdown, false), [markdown]);

	return (
		<Box
			xcss={[
				containerStyles,
				!fg('kd_sain_enable_expand_when_streaming') && containerStylesWithoutStreamingExpand,
			]}
		>
			<Suspense fallback={<Fragment />}>
				{fg('kd_smart_answers_use_adf_encoder') || fg('kd_smart_answers_use_adf_encoder_jira') ? (
					<ReactRenderer
						document={docContent}
						nodeComponents={{
							status: (props) => <StatusCitation {...props} />,
							// Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
							// Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
							media: () => <Fragment />,
							mediaSingle: () => <Fragment />,
						}}
					/>
				) : (
					// Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
					// Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
					<MarkdownRenderer disallowedElements={['img']}>{markdown}</MarkdownRenderer>
				)}
			</Suspense>
		</Box>
	);
};
